import { fileWriter } from "./FileUtils";

const replaceSpecialCharacters = (content) => {
  content = encodeURI(content).replace(/%E2%80%8B/g, "");
  return decodeURI(content);
};

const downloadCSVTemplate = (fileName, headers, content) => {
  let csvContent = headers.join(",") + "\n";
  content.forEach((row) => {
    csvContent +=
      Object.values(row)
        .map((cell) => {
          if (typeof cell === "string") {
            cell = cell.replace(/"/g, '""'); // Escape double quotes
            cell = cell.replace("\n", " "); // Remove new lines
            if (cell.includes(",") || cell.includes('"')) {
              cell = `"${cell}"`; // Wrap in double quotes if it contains commas or double quotes
            }
          }
          return cell;
        })
        .join(",") + "\n";
  });

  csvContent = replaceSpecialCharacters(csvContent);

  const file = fileWriter(csvContent, fileName, "text/csv");

  const link = document.createElement("a");
  link.href = URL.createObjectURL(file);
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { downloadCSVTemplate };
